export default class ElectronPlatform {
    public static get isWindows() {
        return process.platform == "win32";
    }

    public static get isMac() {
        return process.platform == "darwin";
    }

    public static get isLinux() {
        return process.platform == "linux";
    }

    public static get isMinimizeToTrayAvailable(): boolean
    {
        return this.isWindows || this.isLinux;
    }

    public static get isUseLatestElectron() {
        let result = true;
        if (this.isWindows) {
            result = parseInt(require("os").release().split(".")[0]) >= 10;
        } else if (this.isMac) {
            result = parseInt(require("os").release().split(".")[0]) >= 21;
        }
        return result;
    }
}